module.exports = __webpack_public_path__ + "static/media/PB_Y_12.ad1c0172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_12.png
// module id = 241
// module chunks = 0